import api from './index';
//
let exports = {};

exports.getShopLowCostStuffInfo = function (params, callback) {// 低值易耗品-详情
    api.get('/shop/stuff/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getShopLowCostStuffList = function (data, callback) {// 低值易耗品-分页列表
    api.post('/shop/stuff/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getShopLowCostStuffListForSelect = function (data, callback) {// 低值易耗品-列表 -forSelect
    api.post('/shop/stuff/page/list/get/for/select')
    .data(data)
    .done(callback)
    .go();
};

exports.getShopLowCostStuffListForCollect = function (data, callback) {// 低值易耗品-列表 -- 汇总
    api.post('/shop/stuff/page/list/get/for/collect')
    .data(data)
    .done(callback)
    .go();
};

exports.shopLowCostStuffSetForTheValve = function (data, callback) {// 低值易耗品 - 预警值设置
    api.post('/shop/stuff/theValve/set')
    .data(data)
    .done(callback)
    .go();
};

exports.doShopStuffPrincipalSet = function (data, callback) {// 低值易耗品 - 批量设置责任人-责任部门
    api.post('/shop/stuff/update/principal/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateShopLowCostStuffCurNvQuantity = function (data, callback) {// 低值易耗品 - 报废
    api.post('/shop/stuff/curNvQuantity/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doClearShopLowCostStuff = function (data, callback) {// 低值易耗品 - 报废
    api.post('/shop/stuff/cleared/set/do')
    .data(data)
    .done(callback)
    .go();
};

exports.shopLowCostStuffListForExport = function (data, callback) {// 低值易耗品 - 导出列表
    api.post('/shop/stuff/list/export/do')
    .data(data)
    .done(callback)
    .go();
};

exports.saveStuffModelForExport = function (data, callback) {// 低值易耗品 - 导出耗材贴码
    api.post('/shop/stuff/exp/model/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveStuffParamsForExport = function (data, callback) {// 低值易耗品 - 导出耗材贴码
    api.post('/shop/stuff/exp/params/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 根据ID获取低值易耗品现有数量
exports.getShopLowCostStuffCurQuantity = function (params, callback) {
    api.get('/shop/stuff/curQuantity/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存易耗品图片
exports.updateShopLowCostStuff = function (data, callback) {
    api.post('/shop/stuff/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// @date 2019-02-24 @auther libin @desc 增加操作记录查询
// 设备操作记录
exports.getShopStuffRecList = function (params, callback) {
    api.post('/shop/stuff/act/rec/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// @date 2019-02-24 @auther libin @desc 增加操作记录查询
// 设备操作记录
exports.getShopStuffRecPageList = function (params, callback) {
    api.post('/shop/stuff/act/rec/page/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// ======================= 易耗品出入库 ==============

exports.getStuffIoRecordById = function (params, callback) {// 易耗品出入库 - 详情
    api.get('/shop/stuff/io/record/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getStuffIoRecordListByFilter = function (data, callback) {// 易耗品出入库 - 列表
    api.post('/shop/stuff/io/record/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ============================== 耗材盘点单 ==========================

// 耗材盘点单-分页查询
exports.getShopStuffStockCheckVoucherList = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 耗材盘点单-根据id查询
exports.getShopStuffStockCheckVoucher = function (params, callback) {
    api.get('/shop/stuff/stock/check/voucher/get/by/id')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 耗材盘点单-根据ids查询
exports.getShopStuffStockCheckVoucherListByIds = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/list/by/ids')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 耗材盘点ItemList-不分页查询
exports.getShopStuffStockCheckItemListNotPage = function (params, callback) {
    api.post('/shop/stuff/stock/check/item/list/get/not/page')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 耗材盘点ItemList-分页查询
exports.getShopStuffStockCheckItemList = function (params, callback) {
    api.post('/shop/stuff/stock/check/item/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.exportShopStuffStockCheckVoucher = function (params, callback) {
    api.get('/shop/stuff/stock/check/voucher/export/get/by/id')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 耗材盘点单-保存
exports.saveShopStuffStockCheckVoucher = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 耗材盘点单-修改
exports.updateShopStuffStockCheckVoucher = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/update/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 耗材盘点单-开始
exports.doShopStuffStockCheckVoucherStart = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/start/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 耗材盘点单-结束
exports.doShopStuffStockCheckVoucherEnd = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/end/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 耗材盘点单-取消
exports.doShopStuffStockCheckVoucherCancel = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/cancel/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 耗材盘点单-删除
exports.deleteShopStuffStockCheckVoucher = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点单-指定自盘负责人
exports.updateShopStuffStockCheckVoucherPrincipal = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/update/principal/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点单-指定复盘负责人
exports.updateShopStuffStockCheckVoucherSpotPrincipal = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/update/spotPrincipal/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点单-指定结果处理执行人
exports.updateShopStuffStockCheckVoucherAssignDoneStaff = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/update/assignDoneStaff/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点单-自盘负责人确认
exports.doShopStuffStockCheckVoucherConfirm = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/confirm/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点单-复盘负责人确认
exports.doShopStuffStockCheckVoucherSpotConfirm = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/spot/confirm/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点单条目-根据id
exports.getShopStuffStockCheckItemById = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/item/get/by/id')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点处理项根据id查询
exports.getShopStuffStockHandleItemMapByVoucherId = function (params, callback) {
    api.get('/shop/stuff/stock/handle/item/map/get/by/voucherId')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 查询盘点结果
exports.getShopStuffStockHandleItemsByVoucherId = function (data, callback) {
    api.post('/shop/stuff/stock/handle/items/get/voucherId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点处理项根据id查询
exports.getShopStuffStockHandleItemById = function (params, callback) {
    api.post('/shop/stuff/stock/handle/item/get/by/id')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点处理项根据voucherItemId查询
exports.getShopStuffStockHandleItemsByVoucherItemId = function (params, callback) {
    api.post('/shop/stuff/stock/handle/item/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 查询（零售）门店设备盘点处理项是否全部审核通过
exports.getShopStuffStockHandleItemsAuditPassFlagByVoucherId = function (params, callback) {
    api.get('/shop/stuff/stock/handle/item/auditPassFlag/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 查询盘点结果
exports.getShopStuffStockHandleItemWayMap = function (data, callback) {
    api.get('/shop/stuff/stock/handle/item/way/get/voucherId')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
//（零售）门店设备盘点单-申请
exports.doApplyShopStuffStockCheckVoucher = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/apply/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 零售）门店设备盘点单 - 处理结束-操作
exports.doFinishedHandleStuffStockCheck = function (params, callback) {
    api.post('/shop/stuff/stock/handle/finished/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点处理项-保存
exports.saveShopStuffStockHandleItem = function (params, callback) {
    api.post('/shop/stuff/stock/handle/item/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点处理项-修改
exports.updateShopStuffStockHandleItem = function (params, callback) {
    api.post('/shop/stuff/stock/handle/item/update/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点处理项-删除
exports.deleteShopStuffStockHandleItemById = function (params, callback) {
    api.post('/shop/stuff/stock/handle/item/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店设备盘点处理项-审核
exports.doAuditShopStuffStockHandleItem = function (params, callback) {
    api.post('/shop/stuff/stock/handle/item/audit/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点处理项-执行-根据id
exports.doShopStuffStockHandleItemDone = function (params, callback) {
    api.post('/shop/stuff/stock/handle/item/done/do/by/id')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店耗材盘点处理项-执行-根据voucherId
exports.doShopStuffStockHandleItemDoneByVoucherId = function (params, callback) {
    api.post('/shop/stuff/stock/handle/item/done/do/by/voucherId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 上传盘点附件-操作
exports.saveShopStuffStockFile = function (data, callback) {
    api.post('/shop/stuff/stock/file/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 查询盘点附件-操作
exports.getShopStuffStockFileListByVoucherId = function (data, callback) {
    api.post('/shop/stuff/stock/file/get/by/voucherId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// =========================== 耗材调拨单管理 =================================

// 耗材调拨单列表
exports.getStuffTransVoucherList = function (data, callback) {
    api.post('/shop/stuff/trans/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 调拨单详情
exports.getStuffTransVoucherInfo = function (params, callback) {
    api.post('/shop/stuff/trans/voucher/info/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getstuffTransVoucherItems = function (params, callback) {
    api.post('/shop/stuff/trans/voucher/item/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 保存调拨信息
exports.saveStuffTransVoucher = function (data, callback) {
    api.post('/shop/stuff/trans/voucher/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 编辑调拨信息
exports.updateShopStuffTransVoucherInfo = function (data, callback) {
    api.post('/shop/stuff/trans/voucher/info/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 调拨申请操作
exports.applyStuffTransVoucher = function (data, callback) {
    api.post('/shop/stuff/trans/voucher/apply/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 调拨审核操作
exports.auditStuffTransVoucher = function (data, callback) {
    api.post('/shop/stuff/trans/voucher/audit/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 调拨确认操作
exports.confirmStuffTransVoucher = function (data, callback) {
    api.post('/shop/stuff/trans/voucher/confirm/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 调拨单删除操作
exports.deleteStuffTransVoucher = function (data, callback) {
    api.post('/shop/stuff/trans/voucher/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取调拨单审核操作记录列表
exports.getStuffTransAuditRecListByVoucherId = function (params, callback) {
    api.get('/shop/stuff/trans/audit/rec/list/get/by/voucherId')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取调拨单审核操作记录列表
exports.getStuffTransVoucherAppStateTodoCount = function (data, callback) {
    api.post('/shop/stuff/trans/voucher/applyState/to-do/count/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取调拨单审核操作记录列表
exports.getStuffTransVoucherConfirmTodoCount = function (params, callback) {
    api.get('/shop/stuff/trans/voucher/confirm/to-do/count/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取调拨单审核操作记录列表
exports.saveStuffTransVoucherFile = function (data, callback) {
    api.post('/shop/stuff/trans/file/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取调拨单审核操作记录列表
exports.getStuffTransVoucherFileListByVoucherId = function (params, callback) {
    api.get('/shop/stuff/trans/file/get/by/voucherId')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 作废调拨单
exports.doInvalidTransVoucher = function (data, callback) {
    api.post('/shop/stuff/trans/voucher/invalid/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ============================== 耗材导入 ==========================

//门店耗材导入记录分页列表
exports.getShopStuffImpRecListByFilter = function (data, callback) {
    api.post('/shop/stuff/imp/rec/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

//根据id查询 门店耗材导入记录 带详细
exports.getShopStuffImpRecById = function (data, callback) {
    api.post('/shop/stuff/imp/rec/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}
//耗材导入记录详细列表(分页)
exports.getShopStuffImpItemPageListByFilter = function (data, callback) {
    api.post('/shop/stuff/imp/item/page/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

//门店耗材导入记录详细列表(不分页)
exports.getShopStuffImpItemListByFilter = function (data, callback) {
    api.post('/shop/stuff/imp/item/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

//根据文件名和店铺id检验是否重复导入
exports.validateImpFileRepetition = function (data, callback) {
    api.post('/shop/stuff/imp/file/repetition/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

//提交门店导入耗材导出数据，返回下载url
exports.saveStuffImpModelForExport = function (data, callback) {
    api.post('/shop/stuff/imp/model/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

//验证/修正耗材导入数据
exports.validateStuffImpModel = function (data, callback) {
    api.post('/shop/stuff/imp/model/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}
exports.validateStuffTitle = function (data, callback) {
    api.post('/shop/stuff/imp/model/devc/name/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}
//执行耗材模型信息导入，返回导入记录Id
exports.doStuffImpModelImport = function (data, callback) {
    api.post('/shop/stuff/imp/model/import/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

// ============================== 领用/归还单 ==========================

exports.getStuffAppturnVoucherList = function (data, callback) {// 领用/归还单分页列表
    api.post('/shop/stuff/appturn/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getStuffAppturnVoucherInfo = function (params, callback) {// 领用/归还单详情
    api.get('/shop/stuff/appturn/voucher/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getStuffAppturnVoucherInfoByUpdate = function (params, callback) {// 领用/归还单详情
    api.post('/shop/stuff/appturn/voucher/get/info')
    .data(params)
    .done(callback)
    .go();
};

exports.doStuffAppturnVoucherSave = function (data, callback) {// 领用/归还单保存
    api.post('/shop/stuff/appturn/voucher/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.doStuffAppturnVoucherUpdate = function (data, callback) {// 领用/归还单修改
    api.post('/shop/stuff/appturn/voucher/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 申请领用单
exports.updateStuffAppturnVoucherApply = function (data, callback) {
    api.post('/shop/stuff/appturn/voucher/apply/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 审核领用单
exports.updateStuffAppturnVoucherAduit = function (data, callback) {
    api.post('/shop/stuff/appturn/voucher/aduit/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 删除领用单
exports.deleteStuffAppturnVoucher = function (data, callback) {
    api.post('/shop/stuff/appturn/voucher/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getStuffAppturnItemList = function (data, callback) {// 领用/归还单 项分页列表
    api.post('/shop/stuff/appturn/item/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 部门申领
exports.getStuffAppturnVoucherItemDepartStatis = function (data, callback) {
    api.post('/shop/stuff/appturn/voucher/item/depart/statis/get')
    .data(data)
    .done(callback)
    .go();
};
// 人员领用
exports.getStuffAppturnItemDepartStaffStatis = function (data, callback) {
    api.post('/shop/stuff/appturn/voucher/item/depart/staff/statis/get')
    .data(data)
    .done(callback)
    .go();
};

// ========================== 易耗品出入库单 ============================

// 出入单列表查询
exports.getStuffIoVoucherList = function (data, callback) {
    api.post('/shop/stuff/io/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 保存固定资产出入库单
exports.saveStuffIoVoucher = function (data, callback) {
    api.post('/shop/stuff/io/voucher/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

// 入库单-条目查询-不分页-带其他参数
exports.getStuffIoItemList = function (data, callback) {
    api.post('/shop/stuff/io/item/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

// 清除易耗品保存
exports.doClearShopStuffIoVoucher = function (data, callback) {
    api.post('/shop/stuff/io/voucher/clear/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 出入库单详情
exports.getStuffIoVoucherById = function (params, callback) {
    api.get('/shop/stuff/io/voucher/get/by/id')
    .params(params)
    .done(callback)
    .go();
};

// ============================= 报废单据 ============================
// date 2019-02-28 @auther libin @desc 新增报废单据
// 分页查询报废单据
exports.getStuffScrapVoucherList = function (data, callback) {
    api.post('/shop/stuff/scrap/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 固定资产出入库单查询
exports.getStuffScrapVoucherById = function (data, callback) {
    api.post('/shop/stuff/scrap/voucher/get/by/id')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 固定资产出入库单查询
exports.getStuffScrapVoucher = function (params, callback) {
    api.get('/shop/stuff/scrap/voucher/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 固定资产出入库单查询
exports.getStuffScrapItemList = function (data, callback) {
    api.post('/shop/stuff/scrap/item/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 保存修改报废单据
exports.saveStuffScrapVoucher = function (data, callback) {
    api.post('/shop/stuff/scrap/voucher/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 申请报废单据
exports.applyStuffScrapVoucher = function (data, callback) {
    api.post('/shop/stuff/scrap/voucher/apply/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 审核报废单据
exports.aduitStuffScrapVoucher = function (data, callback) {
    api.post('/shop/stuff/scrap/voucher/aduit/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 删除报废单据
exports.deleteStuffScrapVoucher = function (data, callback) {
    api.post('/shop/stuff/scrap/voucher/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ============================= 清理单据 ============================
// date 2019-02-28 @auther libin @desc 新增报废单据
// 分页查询报废单据
exports.getStuffClearVoucherList = function (data, callback) {
    api.post('/shop/stuff/clear/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 易耗品清理单查询 - 包含单项信息
exports.getStuffClearVoucherIncludeItems = function (data, callback) {
    api.post('/shop/stuff/clear/voucher/get/include/items')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 易耗品清理单查询
exports.getStuffClearVoucherInfo = function (params, callback) {
    api.get('/shop/stuff/clear/voucher/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 易耗品清理单项 - 分页列表
exports.getStuffClearItemList = function (data, callback) {
    api.post('/shop/stuff/clear/item/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 保存修改清理单据
exports.saveStuffClearVoucher = function (data, callback) {
    api.post('/shop/stuff/clear/voucher/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 申请报废单据
exports.applyStuffClearVoucher = function (data, callback) {
    api.post('/shop/stuff/clear/voucher/apply/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 审核报废单据
exports.aduitStuffClearVoucher = function (data, callback) {
    api.post('/shop/stuff/clear/voucher/aduit/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 删除报废单据
exports.deleteStuffClearVoucher = function (data, callback) {
    api.post('/shop/stuff/clear/voucher/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 删除报废单据
exports.doMerchtDevcDefRelComDevcDefItem = function (data, callback) {
    api.post('/shop/stuff/def/rel/com/devc/def/item/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateShopLowCostStuffBizTagByIds = function (data, callback) {//批量修改标签
    api.post('/shop/stuff/bizTag/update/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateShopLowCostStuffBizTagById = function (data, callback) {//修改标签
    api.post('/shop/stuff/bizTag/update/by/id')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateAssetKind = function (data, callback) {//财务类别-批量设置
    api.post('/shop/stuff/asset/kind/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopStuffStockCheckVoucherItems = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/items/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doStuffStockBatchCheck = function (params, callback) {
    api.post('/shop/stuff/stock/batch/check/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateShopStuffStockCheckVoucherPostAddedMemo = function (params, callback) {
    api.post('/shop/stuff/stock/check/voucher/postAddedMemo/update/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 提交盘点明细导出数据，返回导出文件所需uuid
exports.saveStuffCheckItemModelForExport = function (data, callback) {
    api.post('/shop/stuff/exp/check/item/model/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}
// 提交盘点明细导出过滤参数，返回导出文件所需uuid
exports.saveStuffCheckItemParamsForExport = function (data, callback) {
    api.post('/shop/stuff/exp/check/item/params/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/shopStuff.js
// module id = 22
// module chunks = 0